import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import config from "../../config";
import makeRequest from "../../makeRequest";

const BASE = config.api.baseUrl;

const ARROW = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    className="mh-lf-card__cta-arrow"
    aria-hidden="true"
  >
    <line x1="5" y1="12" x2="19" y2="12" />
    <polyline points="12 5 19 12 12 19" />
  </svg>
);

const PLACEHOLDER = (
  <svg
    className="mh-lf-card__img-placeholder"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.2"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M22 12h-4l-3 9L9 3l-3 9H2" />
  </svg>
);

const EXT_ICON = (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    style={{ width: 11, height: 11, opacity: 0.55, marginLeft: 3, flexShrink: 0, verticalAlign: "middle" }}
    aria-hidden="true"
  >
    <path d="M18 13v6a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h6" />
    <polyline points="15 3 21 3 21 9" />
    <line x1="10" y1="14" x2="21" y2="3" />
  </svg>
);

const WOW_DELAYS = [".1s", ".2s", ".3s", ".4s", ".5s", ".6s", ".7s", ".8s"];

function FeatureBtn({ item, idx }) {
  const href = item.navigationLink || item.buttonLink || item.value || "/";
  const isExternal = item.isExternal === 1 || item.isExternal === true;
  const ctaLabel = item.buttonName || "View Details";

  const inner = (
    <>
      <div className="mh-lf-card__img-wrap">
        {item.hasImage ? <img src={`${BASE}/website/page/${item.id}/image`} alt={item.name} crossOrigin="anonymous" /> : PLACEHOLDER}
      </div>
      <div className="mh-lf-card__body">
        <div className="mh-lf-card__name">
          {item.name}
          {isExternal && EXT_ICON}
        </div>
        {item.description && <p className="mh-lf-card__desc">{item.description}</p>}
      </div>
      <div className="mh-lf-card__foot">
        <span className="mh-lf-card__cta">
          {ctaLabel}
          {ARROW}
        </span>
      </div>
    </>
  );

  const wrapperClass = `col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30 wow animate__fadeInUp`;

  return (
    <div className={wrapperClass} data-wow-duration=".9s" data-wow-delay={WOW_DELAYS[idx % WOW_DELAYS.length]}>
      {isExternal ? (
        <a href={href} target="_blank" rel="noopener noreferrer" className="mh-lf-card" aria-label={item.name}>
          {inner}
        </a>
      ) : (
        <Link to={href} className="mh-lf-card" aria-label={item.name}>
          {inner}
        </Link>
      )}
    </div>
  );
}

const Feature = () => {
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    makeRequest({
      route: "/website/page/public?key=lookingFor&isActive=1&orderBy=sortOrder&orderByDirection=asc",
      method: "get",
    })
      .then(({ data }) => {
        if (Array.isArray(data) && data.length > 0) setItems(data);
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const displayItems = loading ? Array(4).fill(null) : items;

  return (
    <div className="mh-lf-section fix pt-120 pb-90">
      <div className="container">
        <div className="mh-lf-section__header">
          <span className="mh-lf-section__eyebrow">
            <svg viewBox="0 0 20 20" fill="currentColor" aria-hidden="true">
              <path d="M10 2a1 1 0 011 1v5h5a1 1 0 010 2h-5v5a1 1 0 01-2 0v-5H4a1 1 0 010-2h5V3a1 1 0 011-1z" />
            </svg>
            MIH
          </span>
          <h2 className="mh-lf-section__title">What are you looking for?</h2>
          <p className="mh-lf-section__sub">Compassionate care across every specialty — select a service to get started.</p>
        </div>
        <div className="row gx-4">
          {displayItems.map((item, idx) =>
            item ? (
              <FeatureBtn key={item.id} item={item} idx={idx} />
            ) : (
              <div key={idx} className="col-xl-3 col-lg-4 col-md-6 col-sm-6 mb-30">
                <div className="mh-lf-card mh-lf-card--skeleton">
                  <div className="mh-lf-card__img-wrap" />
                  <div className="mh-lf-card__body" style={{ gap: 8 }}>
                    <div className="mh-lf-sk-line" style={{ width: "65%", height: 14 }} />
                    <div className="mh-lf-sk-line" style={{ width: "90%" }} />
                    <div className="mh-lf-sk-line" style={{ width: "75%" }} />
                  </div>
                  <div className="mh-lf-card__foot">
                    <div className="mh-lf-sk-line" style={{ height: 34, borderRadius: 8 }} />
                  </div>
                </div>
              </div>
            ),
          )}
        </div>
      </div>
    </div>
  );
};

export default Feature;
